import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tracker-filters" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = { class: "buttons" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PulseSearch = _resolveComponent("PulseSearch")
  const _component_PulseButton = _resolveComponent("PulseButton")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_PulseSearch, {
        modelValue: $data.search,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.search) = $event)),
        loading: $props.loading,
        placeholder: "Search companies, people & topics..."
      }, null, 8 /* PROPS */, ["modelValue", "loading"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_PulseButton, {
        active: !$data.type,
        class: "filter-btn",
        text: "All",
        count: $props.typeCounts.all,
        onClick: _cache[1] || (_cache[1] = $event => ($data.type = undefined))
      }, null, 8 /* PROPS */, ["active", "count"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.tracker_types, (item) => {
        return (_openBlock(), _createBlock(_component_PulseButton, {
          key: item.value,
          class: "filter-btn",
          active: item.value === $data.type,
          icon: item.icon,
          "icon-size": "1.6rem",
          text: item.title,
          count: $props.typeCounts[item.value],
          onClick: $event => ($data.type = $data.type === item.value ? undefined : item.value)
        }, null, 8 /* PROPS */, ["active", "icon", "text", "count", "onClick"]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}